
// Create an array to store information about completed fetch requests
const completedFetchRequests = [];

// Store a reference to the original fetch function
const originalFetch = window.fetch;

// Override the fetch function with a custom function
window.fetch = function (url, options) {
  // console.log("called completedFetchRequests")
  // Track the request URL and options
  const requestInfo = { url, options };
  
  // Make the actual fetch request and store the promise
  const fetchPromise = originalFetch(url, options);

  if(url.indexOf(__VariantChangeUrl) >= 0){
    // Add the request info and promise to the completedFetchRequests array
    completedFetchRequests.push({ info: requestInfo, promise: fetchPromise });  
    handleCompletedFetchRequests();
  }

  // Return the fetch promise as if nothing has changed
  return fetchPromise;
};

// Your custom function to handle completed fetch requests
function handleCompletedFetchRequests() {
  completedFetchRequests.forEach((request) => {
    request.promise
      .then((response) => {
        // Handle the response here if needed
        // console.log('Fetch request completed:', request.info.url);
        if(request.info.url.indexOf(__VariantChangeUrl) >= 0){
           setTimeout(function(){
              changeAddToCartBtnText();
           }, 500);
        }
        // return response;
      })
      .catch((error) => {
        // Handle errors here if needed
        console.error('Fetch request error:', request.info.url, error);
        throw error;
      });
  });

  // Optionally, you can clear the completed requests array if needed
  completedFetchRequests.length = 0;
}

// Example usage:
/* fetch('https://jsonplaceholder.typicode.com/posts/1')
  .then(response => response.json())
  .then(data => console.log(data));

Call your custom function to handle completed fetch requests
handleCompletedFetchRequests(); */

/* called when some once change the plan in between subscription & one time */
$(document).on('click', '.sealsubs-target-element.sealsubs-full input[type=radio].sls-option, .sls-label-container.seal-col label, .sls-option-container.seal-table', function(){
  console.log("on plan changed called");
  setTimeout(function(){
    changeAddToCartBtnText()
  },200)
});

function changeAddToCartBtnText(){
  let parentFrm = $("form.sealSubcriptionForm");
          let plan = $(".sealsubs-target-element.sealsubs-full input[type=radio].sls-option:checked").val();
  console.log(`plan = ${plan}`);
          let buttonText = $(parentFrm).find(".ajax-cart-btn .cart-title").text();
          if(plan == 'one_time'){
            if(buttonText.indexOf("Sold out") === -1){ //means whenever sold out text not present
              $(parentFrm).find(".ajax-cart-btn .cart-title").text(`Add to cart`);  
            }else{
              $(parentFrm).find(".ajax-cart-btn .cart-title").text(`Sold out`);  
            }
          }else{
            buttonText = $(parentFrm).find(".ajax-cart-btn .cart-title").text();
            if(buttonText.indexOf("Sold out") === -1){ //means whenever sold out text not present
              $(parentFrm).find(".ajax-cart-btn .cart-title").text(`Subscribe`);  
            }else{
              $(parentFrm).find(".ajax-cart-btn .cart-title").text(`Subscribe sold out`);  
            }
          }
}